var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dpf-icon-wrapper"},[_c('div',{class:_vm.iconClass},[_c('v-icon',{class:_vm.statusIconClass},[_vm._v(" "+_vm._s(_vm.statusIcon)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }